export class BidRequestModel {
    AuctionLotId: number;
    BidAmount: number;
}